module.exports = __webpack_public_path__ + "static/media/preference-orange.d8bb10ab.svg";